// extracted by mini-css-extract-plugin
export default {"notifications-portal":"NotificationsPortal_notifications-portal__Jg7Eu","notification":"NotificationsPortal_notification__isU5V"};